import React from 'react';
import { Control, Controller, useFormContext } from 'react-hook-form';
import { MultiSelectUser } from 'v2/form/CustomSelectors/Multiselect/MultiSelectUser/MultiSelectUser';
import { ItemList } from 'v2/models';
import Form from 'react-bootstrap/Form';
import classnames from 'classnames';
import styles from './entityOwnerFilter.module.scss';
import { EFilterOperations } from 'v2/common/ComposeFilters/filters';

interface EntityOwnerFilterValueSelectorProps {
  control: Control;
}

const validateInput = (value: ItemList) => {
  if (!value.is_all) {
    return value.list.length > 0;
  }
  return true;
};

export const EntityOwnerFilterValueSelector = ({
  control,
}: EntityOwnerFilterValueSelectorProps) => {
  return (
    <div className={classnames(styles.multiSelectorContainer)}>
      <Controller
        name="value"
        control={control}
        rules={{
          required: true,
          validate: validateInput,
        }}
        render={({ field: { onChange } }) => {
          return <MultiSelectUser onChange={onChange} />;
        }}
      />
    </div>
  );
};

export const EntityOwnerFilter = () => {
  const { register, watch, control, setValue } = useFormContext();
  const operationState = watch('operation');
  const operationFieldRegister = register('operation', { required: true });

  return (
    <div data-testid="EntityOwnerFilter">
      <Form.Check
        id={`${operationFieldRegister.name}-equals`}
        type="radio"
        label="equals"
        value={EFilterOperations.equals}
        {...operationFieldRegister}
      />
      {operationState === EFilterOperations.equals && (
        <EntityOwnerFilterValueSelector control={control} />
      )}
      <Form.Check
        id={`${operationFieldRegister.name}-not-equals`}
        type="radio"
        label="not equals"
        value={EFilterOperations.notEquals}
        {...operationFieldRegister}
      />
      {operationState === EFilterOperations.notEquals && (
        <EntityOwnerFilterValueSelector control={control} />
      )}
      <Form.Check
        id={`${operationFieldRegister.name}-known`}
        type="radio"
        label="is known"
        value="known"
        {...operationFieldRegister}
      />
      {operationState === EFilterOperations.known &&
        setValue('value', { is_all: false, list: [] })}
      <Form.Check
        id={`${operationFieldRegister.name}-unknown`}
        type="radio"
        label="is unknown"
        value="unknown"
        {...operationFieldRegister}
      />
      {operationState === EFilterOperations.unknown &&
        setValue('value', { is_all: false, list: [] })}
    </div>
  );
};
